import { WriterTicketsRoutes } from '@/modules/shared/routes/writer/support/tickets'
import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'
import { vsingleton } from '@niknevis/vue-modules'

@vsingleton()
export class WriterSupportRoutes {
  constructor(
    public readonly tickets: WriterTicketsRoutes
  ) {
  }

  faqs() {
    return Ziggy
      .route('writer.support.faqs')
      .toString()
  }
}
